import Card, { CardProps } from '@/components/base/card'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'

import { cn } from '@/lib/utils'

export type MediaCardProps = CardProps

const MediaCard = ({
  link,
  media,
  keywords,
  className,
  ...props
}: MediaCardProps) => {
  return (
    <Section className={cn('md:px-margin lg:px-0', className)} {...props}>
      <Grid>
        <div
          className={cn(
            'col-span-2 md:col-span-4 md:col-start-2',
            'lg:col-auto lg:row-span-8 lg:row-start-3'
          )}
        >
          <Card
            link={link}
            media={media}
            keywords={keywords}
            className="w-media-card h-auto w-full lg:h-full"
          />
        </div>
      </Grid>
    </Section>
  )
}

export default MediaCard
